import { useSchemeEditorStore } from "pages/scheme-editor/store"
import { useEffect } from "react"
import { useMainStore } from "store"

const Loader = ({ schemeId }: { schemeId: string | null }) => {

  const mainStore = useMainStore()
  const schemeStore = useSchemeEditorStore()

  useEffect(() => {
    const scheme = (schemeId && mainStore.schemes.get(schemeId)) || null
    schemeStore.schemeId = schemeId
    schemeStore.loadScheme(scheme?.data || null)
  }, [ schemeId ])  // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <></>
  )
}

export default Loader